import React from 'react';
import YouTube from 'react-youtube';

import dabangBridge from '~/utils/bridge';

import mainImg from './images/main_01.png';
import videoImg from './images/video_bg_01.png';

import { BGWrap, Youtube } from './styled';

function SignLesseeInterviewEvent() {
  const link = 'https://master.dt57cx1j6t39u.amplifyapp.com/2022/02/rent-free/';
  function openLink() {
    return alert('');

    dabangBridge.web(call => {
      console.log('web');
      window.location.href = link;
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openInAppBrowser',
        url: link,
      });
    });

    dabangBridge.android(call => {
      console.log('android');
      call.openInAppBrowser(link);
    });
  }

  return (
    <>
      <BGWrap width={710} height={2195} imgUrl={mainImg} />
      <BGWrap width={710} height={421} imgUrl={videoImg}>
        <Youtube>
          <YouTube videoId="PsPFGp2gL2I" />
        </Youtube>
      </BGWrap>
    </>
  );
}

export default SignLesseeInterviewEvent;
